const imgCache = {
  __cache: {} as { [src: string]: boolean | Promise<boolean | void> },
  read(src: string) {
    if (!this.__cache[src]) {
      this.__cache[src] = new Promise((resolve) => {
        const img = new Image();
        img.onload = () => {
          this.__cache[src] = true;
          resolve(this.__cache[src]);
        };
        img.src = src;
      }).then(() => {
        this.__cache[src] = true;
      });
    }
    if (this.__cache[src] instanceof Promise) {
      throw this.__cache[src];
    }
    return Promise.resolve(() => true);
  }
};

interface LazyImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  src: string;
}

const LazyImage: React.FC<LazyImageProps> = ({ src, ...rest }) => {
  imgCache.read(src).catch((err) => console.log(err));
  return <img src={src} {...rest} alt=""/>;
};

export default LazyImage;
